import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  industries: [],
  B2B: {},
  B2C: {},
  B2G: {},
  HNWI: {},
  HLC: {}
}



export const sliceName = "RFQFieldwork"



export const RFQFieldworkSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    handleIndustries: (state, action) => {
      if (state.industries.includes(action.payload)) {
        return { ...state, industries: state.industries.filter(industry => industry !== action.payload) }
      }
      else {
        return { ...state, industries: [...state.industries, action.payload] }
      }
    },
    handleIndustrySpecificData: (state, action) => {
      const industry = action.payload.id;
      return { ...state, [industry]: action.payload.industryData }
    },
    resetFieldwork:()=>{
      return initialState;
    }
  }
})

export const RFQFieldworkDataState = state => state[sliceName]


// Action creators are generated for each case reducer function
export const { handleIndustries, handleIndustrySpecificData,resetFieldwork } = RFQFieldworkSlice.actions

export default RFQFieldworkSlice.reducer